import React, { useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import "./RetirementSetup.css";

const RetirementSetup = () => {
    const { id: businessId } = useParams();

    const [plans, setPlans] = useState([
        {
            type: "",
            employeeContributionLimit: "",
            employerMatch: "",
            matchCap: "",
            notes: "",
            isRoth: false,
            monthsFromStart: "",     // ⬅️ New
            minAge: "",              // ⬅️ New
            startDate: ""  
        }
    ]);

    const handleChange = (index, field, value) => {
        const updated = [...plans];
        updated[index][field] = value;
        setPlans(updated);
    };

    const addPlan = () => {
        setPlans([
            ...plans,
            {
                type: "",
                employeeContributionLimit: "",
                employerMatch: "",
                matchCap: "",
                notes: "",
                isRoth: false 
            }
        ]);
    };

    const removePlan = (index) => {
        const updated = plans.filter((_, i) => i !== index);
        setPlans(updated);
    };

    const handleSave = async () => {
        const payload = plans.map((plan) => ({
          type: plan.type,
          name: `${plan.type.toUpperCase()} Plan`,
          employeeContributionLimit: plan.employeeContributionLimit || null,
          employeePercentCap: plan.employeePercentCap || null,
          employerMatch: plan.employerMatch || null,
          matchCap: plan.matchCap || null,
          notes: plan.notes || null,
          isRoth: plan.isRoth || false,
          monthsFromStart: plan.monthsFromStart || null,
            minAge: plan.minAge || null,
            startDate: plan.startDate || null 
        }));
      
        try {
          await api.post(`/retirement-plans/${businessId}`, { plans: payload });
          alert("Retirement plans saved successfully!");
        } catch (err) {
          console.error("Failed to save plans:", err);
          alert("Error saving plans.");
        }
      };
      

    return (
        <div className="retirement-setup">
            <h2>401(k) / IRA Plan Setup</h2>
            <p>Configure the retirement plans your business offers.</p>
            

            {plans.map((plan, index) => (
                <div key={index} className="retirement-plan-form">
                    <label>
                        Plan Type:
                        <select
                        value={plan.type}
                        onChange={(e) => handleChange(index, "type", e.target.value)}
                        >
                        <option value="">-- Select --</option>
                        <option value="401k">401(k)</option>
                        <option value="safe_harbor_401k">Safe Harbor 401(k)</option>
                        <option value="simple_ira">SIMPLE IRA</option>
                        </select>

                    </label>

                    <label>
                        Roth Contributions Available:
                        <input
                            type="checkbox"
                            checked={plan.isRoth || false}
                            onChange={(e) => handleChange(index, "isRoth", e.target.checked)}
                        />
                        </label>


                        <label>
                    Months from Start (Eligibility):
                    <input
                        type="number"
                        value={plan.monthsFromStart}
                        onChange={(e) => handleChange(index, "monthsFromStart", e.target.value)}
                    />
                    </label>

                    <label>
                    Minimum Age (in years):
                    <input
                        type="number"
                        value={plan.minAge}
                        onChange={(e) => handleChange(index, "minAge", e.target.value)}
                    />
                    </label>

                    <label>
                    Plan Start Date:
                    <input
                        type="date"
                        value={plan.startDate}
                        onChange={(e) => handleChange(index, "startDate", e.target.value)}
                    />
                    </label>



                    <label>
                        Employee Contribution Limit ($):
                        <input
                            type="number"
                            value={plan.employeeContributionLimit}
                            onChange={(e) => handleChange(index, "employeeContributionLimit", e.target.value)}
                        />
                    </label>

                    <label>
                        Employee % Cap (of salary):
                        <input
                            type="number"
                            value={plan.employeePercentCap}
                            onChange={(e) => handleChange(index, "employeePercentCap", e.target.value)}
                        />
                        </label>


                    <label>
                        Employer Match (%):
                        <input
                            type="number"
                            value={plan.employerMatch}
                            onChange={(e) => handleChange(index, "employerMatch", e.target.value)}
                        />
                    </label>

                    <label>
                        Employer Match Cap (% of salary):
                        <input
                            type="number"
                            value={plan.matchCap}
                            onChange={(e) => handleChange(index, "matchCap", e.target.value)}
                        />
                    </label>

                    <label>
                        Notes:
                        <input
                            type="text"
                            value={plan.notes}
                            onChange={(e) => handleChange(index, "notes", e.target.value)}
                        />
                    </label>

                    {plans.length > 1 && (
                        <button type="button" className="remove-btn" onClick={() => removePlan(index)}>
                            Remove
                        </button>
                    )}
                </div>
            ))}

            <div className="plan-buttons">
                <button type="button" onClick={addPlan}>Add Another Plan</button>
                <button type="button" onClick={handleSave}>Save Plans</button>
            </div>
        </div>
    );
};

export default RetirementSetup;
